import { useMemo } from 'react'
import { FlightSegment } from 'constants/flight'
import type { FlightSortOptions } from 'constants/flight'
import { filterSameDayFares, getDepartingSortListV2, getReturningSortListV2 } from 'lib/flights/flightUtils'
import { sortByAll } from 'lib/array/arrayUtils'

interface Params {
  journeys: Array<App.JourneyV2>
  activeSegmentKey: string
  sort: FlightSortOptions
  departDate?: string
  returnDate?: string
  selectedFlights: Record<string, App.JourneyV2>
}

function useChatFlightResultsSorting(params: Params): Array<App.JourneyV2> {
  const {
    journeys,
    activeSegmentKey,
    sort,
    departDate,
    returnDate,
    selectedFlights,
  } = params
  const isReturningStep = activeSegmentKey === FlightSegment.RETURNING

  const sameDayFilteredJourneys = useMemo(() => {
    if (!isReturningStep || !departDate || !returnDate || departDate !== returnDate) {
      return journeys
    }

    const departingFlight = selectedFlights.departing
    return departingFlight ? filterSameDayFares(departingFlight, journeys) : journeys
  }, [departDate, isReturningStep, journeys, returnDate, selectedFlights])

  return useMemo(() => {
    const sortFields = activeSegmentKey === FlightSegment.RETURNING
      ? getReturningSortListV2(sort)
      : getDepartingSortListV2(sort)

    return sortByAll(sameDayFilteredJourneys, sortFields)
  }, [activeSegmentKey, sameDayFilteredJourneys, sort])
}

export default useChatFlightResultsSorting
